import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import formatTimestamp from '../../../i18n/formatTimestamp';

import { Spinner } from '@salesforce/design-system-react';

import './JobTable.scss';

class JobTable extends Component {
  tableData(items) {
    if (!items) {
      return [];
    }
    const formatDate = formatTimestamp(this.props.intl);

    const data = [];

    items.forEach(item => {
      const jobRowId = `job-${item.send.id}`;

      if (item.blocks.length) {
        data.push({
          jobRow: true,
          id: jobRowId,
          emailName: item.send.email_name || '-',
          sendTime: formatDate(item.send.send_date),
          openTime: formatDate(item.open_date),
          clicked: '-'
        });

        item.blocks.forEach(block => {
          const uniqId = `${jobRowId}-block-${block.block_id}`;
          let parentBlockId;
          let parentBlockHidden = false;
          if (block.parentBlock) {
            if (!item.blocks.find(b => b.block_id === block.parentBlock)) {
              parentBlockHidden = true;
            } else {
              parentBlockId = `${jobRowId}-block-${block.parentBlock}`;
            }
          }
          if (
            !parentBlockHidden &&
            !this.props.collapsedRows.includes(jobRowId) &&
            (!parentBlockId ||
              !this.props.collapsedRows.includes(parentBlockId))
          ) {
            data.push({
              jobRow: false,
              id: uniqId,
              parentJob: jobRowId,
              emailName: '-',
              sendTime: formatDate(item.send.send_date),
              openTime: '-',
              jobId: item.send.id,
              blockId: block.block_id
            });
          }
        });
      }
    });
    return data;
  }

  renderJobs() {
    const { formatMessage } = this.props.intl;
    const formatDate = formatTimestamp(this.props.intl);
    const items = this.props.jobs || [];

    return (
      <div className="job-table-container">
        {items.map(item => {
          const selected =
            item.send.job_id === this.props.selectedJobId
              ? 'selected'
              : 'not-selected';
          return (
            <li
              key={`item-${item.send.job_id}`}
              onClick={() => this.props.onJobSelected(item.send.job_id)}
            >
              <div className={`job-list ${selected}`}>
                <span className="job-name">{item.send.email_name}</span>
                <span className="job-time">
                  {formatMessage({
                    id: 'components.ecs.selectionBrowser.jobs.filter.sendDate'
                  })}{' '}
                  - {formatDate(item.send.send_date)}
                </span>
                <span className="job-time">
                  {formatMessage({
                    id: 'components.ecs.selectionBrowser.jobs.filter.openDate'
                  })}{' '}
                  - {formatDate(item.open_date)}
                </span>
              </div>
            </li>
          );
        })}
      </div>
    );
  }

  drawSpinner(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : null;
  }

  render() {
    const { isLoading } = this.props;

    return (
      <React.Fragment>
        {this.renderJobs()}
        {this.drawSpinner(isLoading)}
      </React.Fragment>
    );
  }
}

JobTable.contextTypes = {
  router: PropTypes.object
};

JobTable.propTypes = {
  actions: PropTypes.object,
  filter: PropTypes.shape({
    sendTime: PropTypes.string,
    openTime: PropTypes.string,
    clicked: PropTypes.bool
  }),
  collapsedRows: PropTypes.array,
  jobs: PropTypes.array,
  selectedJobId: PropTypes.string,
  onJobSelected: PropTypes.func,
  isLoading: PropTypes.bool,
  onTableAction: PropTypes.func,
  location: PropTypes.object
};

export default injectIntl(JobTable);
